import { createFileRoute } from "@tanstack/react-router";
import Admin from "@/pages/Admin";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/admin")({
  head: () =>
    seo({
      title: "Admin | Cedar Creek Construction",
      description: "Cedar Creek Construction site administration.",
      path: "/admin",
      noindex: true,
    }),
  component: Admin,
});
